import {ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";
import {ConfigurationService} from "./configuration.service";
import {StringConfigPipe} from "./string-config.pipe";
import {BooleanConfigPipe} from "./boolean-config.pipe";
import {NumberConfigPipe} from "./number-config.pipe";
import {LocalConfigurationService} from "./local-configuration.service";
import {ConfigurationServiceConstants} from "./configuration-service-constants";

@NgModule({
    declarations: [StringConfigPipe, BooleanConfigPipe, NumberConfigPipe],
    exports: [StringConfigPipe, BooleanConfigPipe, NumberConfigPipe]
})
export class ConfigurationModule {
    constructor(@Optional() @SkipSelf() parentModule: ConfigurationModule) {
        if (parentModule) {
            throw new Error('ConfigurationModule is already loaded. Import it in the AppModule only');
        }
    }

    /**
     * Provide the configuration service and the application key used in the configuration context.
     * @param config
     * @return ModuleWithProviders
     */
    static forRoot(config: ConfigurationConfig): ModuleWithProviders<ConfigurationModule> {
        return {
            ngModule: ConfigurationModule,
            providers: [
                ConfigurationService, LocalConfigurationService,
                {provide: ConfigurationServiceConstants.APPLICATION_KEY, useValue: config.application},
                {provide: ConfigurationServiceConstants.LOCAL_CONFIG_FILE_KEY, useValue: config.localConfigFile},
                {provide: ConfigurationServiceConstants.CONTEXT_NAMES_KEY, useValue: config.contextNames}
            ]
        };
    }
}

export class ConfigurationConfig {
    application: string;
    localConfigFile: string;
    contextNames: string[];
}
